import apiFactory from '@/api/default';
const API = apiFactory('tasks');

// two types of tasks:
// - synchronous tasks that return a result that affects the frontend upon completion
// - asynchronous tasks that run in the background and are only monitored
const state = {
  allTasks: [],
};

const getters = {
  runningTasks: (state) => {
    const filtered = state.allTasks.filter((task) => task._id && task.product && task.service);
    return filtered;
  },
};

const mutations = {
  setBackgroundTasks: (state, runningTasks) => {
    state.allTasks = runningTasks;
  },
  appendBackgroundTask: (state, newTask) => {
    state.allTasks.push(newTask);
  },
};

const actions = {
  async updateBackgroundTask({commit}) {
    const response = await API.search({status: 0, $populate: [{'path': 'product'}]});
    commit('setBackgroundTasks', response.data);
  },
  async createSyncTask({dispatch, commit}, data) {
    const response = await API.create(data.template);
    // we cannot populate the product name for POST requests, so use the value passed from the creator of the task
    // if available
    if ('productName' in data) {
      response.data.product = {'name': data.productName};
    }
    // FIXME: order may change after we poll the first time!
    commit('appendBackgroundTask', response.data);
    for (let i = 0; i < 120; i++) {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      const taskData = await API.load(response.data._id);
      if (taskData.data.status === 1) {
        await data.callback(taskData.data.result);
        dispatch('updateBackgroundTask');
        this.conversionTask = null;
        break;
      }
      if (taskData.data.status === -1) {
        dispatch('updateBackgroundTask');
        this.conversionTask = null;
        break;
      }
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
